export function search(state) {
	return state.search
}

export function selected_areas(state) {
	return state.selected_areas
}

export function selected_categories(state) {
	return state.selected_categories
}

export function selected_tags(state) {
	return state.selected_tags
}

export function selected_extensions(state) {
	return state.selected_extensions
}

export function loading(state) {
	return state.loading
}
